import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Layout from "@/components/revenueos/Layout";
import Home from "@/pages/Home";
import Universe from "@/pages/Universe";
import Signals from "@/pages/Signals";
import Leads from "@/pages/Leads";
import Opportunities from "@/pages/Opportunities";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Funnel from "@/pages/Funnel";
import Orders from "@/pages/Orders";
import Tickets from "@/pages/Tickets";
import Reorder from "@/pages/Reorder";
import Meetings from "@/pages/Meetings";
import Tasks from "@/pages/Tasks";
import Partners from "@/pages/Partners";
import PeopleDirectory from "@/pages/PeopleDirectory";
import Marketing from "@/pages/Marketing";
import Approvals from "@/pages/Approvals";
import Finance from "@/pages/Finance";
import AuditLog from "@/pages/AuditLog";
import Admin from "@/pages/Admin";
import Trash from "@/pages/Trash";
import CustomerPresentations from "@/pages/CustomerPresentations";
import TechnicalProposals from "@/pages/TechnicalProposals";
import CommercialProposals from "@/pages/CommercialProposals";
import Chat from "@/pages/Chat";
import Settings from "@/pages/Settings";
import { RouteGuard } from "@/components/revenueos/RouteGuard";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--text-muted)] text-[13px]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Home />} />
              {/* 8-stage revenue process */}
              <Route path="universe" element={<RouteGuard module="universe"><Universe /></RouteGuard>} />
              <Route path="signals" element={<RouteGuard module="signals"><Signals /></RouteGuard>} />
              <Route path="leads" element={<RouteGuard module="leads"><Leads /></RouteGuard>} />
              <Route path="opportunities" element={<RouteGuard module="opportunities"><Opportunities /></RouteGuard>} />
              <Route path="opportunities/:id" element={<RouteGuard module="opportunities"><OpportunityDetail /></RouteGuard>} />
              <Route path="funnel" element={<RouteGuard module="opportunities"><Funnel /></RouteGuard>} />
              <Route path="orders" element={<RouteGuard module="orders"><Orders /></RouteGuard>} />
              <Route path="tickets" element={<RouteGuard module="customers"><Tickets /></RouteGuard>} />
              <Route path="reorder" element={<RouteGuard module="orders"><Reorder /></RouteGuard>} />
              {/* Tools */}
              <Route path="meetings" element={<RouteGuard module="customers"><Meetings /></RouteGuard>} />
              <Route path="tasks" element={<RouteGuard module="customers"><Tasks /></RouteGuard>} />
              <Route path="partners" element={<PeopleDirectory type="partners" />} />
              <Route path="team" element={<PeopleDirectory type="team" />} />
              <Route path="partner-management" element={<RouteGuard module="partner_assignments"><Partners /></RouteGuard>} />
              <Route path="marketing" element={<RouteGuard module="marketing"><Marketing /></RouteGuard>} />
              <Route path="approvals" element={<RouteGuard module="approvals"><Approvals /></RouteGuard>} />
              <Route path="finance" element={<RouteGuard module="finance"><Finance /></RouteGuard>} />
              <Route path="audit" element={<RouteGuard module="audit_log"><AuditLog /></RouteGuard>} />
              <Route path="admin" element={<RouteGuard admin><Admin /></RouteGuard>} />
              <Route path="trash" element={<RouteGuard anyWriteModules={["universe", "signals", "leads", "opportunities"]}><Trash /></RouteGuard>} />
              <Route path="repositories/customer-presentations" element={<RouteGuard module="repositories"><CustomerPresentations /></RouteGuard>} />
              <Route path="repositories/technical-proposals" element={<RouteGuard module="repositories"><TechnicalProposals /></RouteGuard>} />
              <Route path="repositories/commercial-proposals" element={<RouteGuard module="repositories"><CommercialProposals /></RouteGuard>} />
              <Route path="chat" element={<Chat />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
